import { ButtonAction } from './action-button.constant';

export const PRIMARY_BUTTONS: ButtonAction[] = [
  ButtonAction.Create,
  ButtonAction.Clone,
  ButtonAction.Update,
  ButtonAction.Save,
  ButtonAction.Approve,
  ButtonAction.Activate,
  ButtonAction.Delete,
  ButtonAction.Apply,
  ButtonAction.Send,
  ButtonAction.Publish,
  ButtonAction.Reset,
  ButtonAction.Accept,
  ButtonAction.Navigate,
];

export const BUTTONS_TEXT = {
  [ButtonAction.Update]: 'Save',
  [ButtonAction.GoBack]: 'Go Back',
};
